import {  Color3, DirectionalLight, FollowCamera, FreeCameraDeviceOrientationInput, Mesh, MeshBuilder, Node, ShadowGenerator, StandardMaterial, Vector3 } from "@babylonjs/core";

/**
 * This represents a script that is attached to a node in the editor.
 * Available nodes are:
 *      - Meshes
 *      - Lights
 *      - Cameas
 *      - Transform nodes
 * 
 * You can extend the desired class according to the node type.
 * Example:
 *      export default class MyMesh extends Mesh {
 *          public onUpdate(): void {
 *              this.rotation.y += 0.04;
 *          }
 *      }
 * The function "onInitialize" is called immediately after the constructor is called.
 * The functions "onStart" and "onUpdate" are called automatically.
 */
export default class GameCore extends Mesh {
    /**
     * Override constructor.
     * @warn do not fill.
     */
    // @ts-ignore ignoring the super call as we don't want to re-init
    protected constructor() { }

    /**
     * Called on the node is being initialized.
     * This function is called immediatly after the constructor has been called.
     */
    public onInitialize(): void {




    }

    /**
     * Called on the scene starts.
     */
    public onStart(): void {
        let scene = this.getScene();
        // const xr = scene.createDefaultXRExperienceAsync();
        // var xrHelper = scene.createDefaultXRExperienceAsync();
        //     // Enable VR
        //var vrHelper = scene.createDefaultVRExperience({createDeviceOrientationCamera:false, useXR: true});
        // vrHelper.enableTeleportation({floorMeshes: [scene.getMeshByName("Ground") as Mesh]});

        // vrHelper.onAfterEnteringVRObservable.add(()=>{
        //     if(scene.activeCamera === vrHelper.vrDeviceOrientationCamera){
        //         FreeCameraDeviceOrientationInput.WaitForOrientationChangeAsync(1000).then(()=>{
        //             // Successfully received sensor input
        //         }).catch(()=>{
        //             alert("Device orientation camera is being used but no sensor is found, prompt user to enable in safari settings");
        //         })
        //     }
        // })

    }

    /**
     * Called each frame.
     */
    public onUpdate(): void {
        // ...
    }

    /**
     * Called on the object has been disposed.
     * Object can be disposed manually or when the editor stops running the scene.
     */
    public onStop(): void {
        // ...
    }

    /**
     * Called on a message has been received and sent from a graph.
     * @param message defines the name of the message sent from the graph.
     * @param data defines the data sent in the message.
     * @param sender defines the reference to the graph class that sent the message.
     */
    public onMessage(name: string, data: any, sender: any): void {
        switch (name) {
            case "myMessage":
                // Do something...
                break;
        }
    }
}
